// extracted by mini-css-extract-plugin
export var dropdownContainer = "bf_dq";
export var dropdownWrapper = "bf_dt";
export var errorInput = "bf_dv";
export var errorLabel = "bf_dr";
export var textlabel = "bf_ds";